import {
  Directive,
  HostListener,
  Output,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  EventEmitter,
  Optional,
  Inject
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

@Directive({
  selector: '[appFilePicker]',
  exportAs: 'appFilePicker'
})
export class FilePickerDirective implements OnDestroy, OnChanges {
  private _form: HTMLFormElement;

  @HostListener('dragover', ['$event'])
  _onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  @HostListener('drop', ['$event'])
  _drop(event: DragEvent) {
    event.preventDefault();
    const files = event.dataTransfer.files;
    this._nativeFileElement.files = files;
    this._onFilesChanged();
  }

  @HostListener('click', ['$event'])
  _onClick(event: Event) {
    event.preventDefault();
    this._nativeFileElement.click();
  }

  @Input()
  set multiple(val: boolean) {
    this._multiple = coerceBooleanProperty(val);
  }
  get multiple() {
    return this._multiple;
  }
  // tslint:disable-next-line:member-ordering
  private _multiple = false;

  // tslint:disable-next-line:member-ordering
  @Output() filesChanged = new EventEmitter<FileList>();

  // tslint:disable-next-line:member-ordering
  @Output() filesReset = new EventEmitter();

  get files(): FileList | undefined {
    return this._nativeFileElement.files;
  }

  get nativeFileElement() {
    return this._nativeFileElement;
  }
  // tslint:disable-next-line:member-ordering
  private _nativeFileElement: HTMLInputElement;

  private _onFilesChanged = () => {
    this.filesChanged.emit(this._nativeFileElement.files);
  };

  // tslint:disable-next-line:member-ordering
  constructor(@Optional() @Inject(DOCUMENT) private _document: Document) {
    if (this._document) {
      this._form = this._document.createElement('form');
      this._nativeFileElement = this._document.createElement('input');
      this._nativeFileElement.type = 'file';
      this._nativeFileElement.multiple = this.multiple;
      this._nativeFileElement.addEventListener('change', this._onFilesChanged);
      this._form.appendChild(this.nativeFileElement);
    }
  }

  // tslint:disable-next-line:member-ordering
  ngOnChanges(changes: SimpleChanges) {
    if (changes.multiple) {
      this._nativeFileElement.multiple = this.multiple;
    }
  }

  // tslint:disable-next-line:member-ordering
  ngOnDestroy() {
    this._nativeFileElement.removeEventListener('change', this._onFilesChanged);
    this._nativeFileElement.remove();
    this._form.remove();
  }

  // tslint:disable-next-line:member-ordering
  reset() {
    this._form.reset();
    this.filesReset.emit();
  }
}
